import React from 'react';
import { FaCalendarCheck } from 'react-icons/fa';

export const ProDashConsultationsTab = ({ consultations }) => (
  <div className="bg-white rounded-xl shadow-sm p-6">
    <h3 className="font-bold text-gray-900 mb-4">Your Consultations</h3>
    {consultations.length === 0 ? (
      <div className="text-center py-8">
        <FaCalendarCheck className="text-4xl text-gray-300 mx-auto mb-4" />
        <p className="text-gray-600 mb-2">No consultations yet</p>
        <p className="text-sm text-gray-500">
          When families book consultations with you, they'll appear here.
        </p>
      </div>
    ) : (
      <div className="space-y-4">
        {consultations.map((consultation) => (
          <div key={consultation.consultation_id || consultation.created_at} className="border border-gray-200 rounded-lg p-4">
            <div className="flex justify-between items-start">
              <div>
                <p className="font-medium text-gray-900">{consultation.family_name || 'Family Consultation'}</p>
                <p className="text-sm text-gray-600">
                  {new Date(consultation.scheduled_date).toLocaleDateString()} at{' '}
                  {new Date(consultation.scheduled_date).toLocaleTimeString()}
                </p>
              </div>
              <span className={`px-2 py-1 rounded text-sm ${
                consultation.status === 'confirmed' ? 'bg-emerald-100 text-emerald-700' :
                consultation.status === 'pending' ? 'bg-amber-100 text-amber-700' :
                consultation.status === 'completed' ? 'bg-blue-100 text-blue-700' :
                'bg-gray-100 text-gray-700'
              }`}>
                {consultation.status}
              </span>
            </div>
            {consultation.notes && (
              <p className="mt-2 text-sm text-gray-600">{consultation.notes}</p>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
);
